<template>
  <div v-if="titleId">
    <h2
      :id="`title-${titleId}`"
      :class="`mist-${language}-h2 has-text-left line ${
        animate ? 'invisible' : ''
      }`"
      :style="`font-weight:${fontWeight}!important;`"
    >
      <span
        :style="`${
          inLineLocal
            ? `border-bottom: 1px solid #${subTitle ? '828282' : '002a65'}`
            : ''
        }`"
      >
        {{ title }}
        <div
          v-if="!inLineLocal"
          :id="`title-line-${titleId}`"
          :class="`line ${animate ? 'invisible' : ''}`"
          :style="`border-bottom: 1px solid #${subTitle ? '828282' : '002a65'}`"
        />
      </span>
    </h2>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  props: ["title", "fontWeight", "subTitle", "inLine", "animate"],
  data() {
    return {
      screenSize: null,
      inLineLocal: null,
    };
  },
  mounted() {
    const me = this;
    console.log(this.animate);
    if (this.animate) {
      const interval = setInterval(function () {
        if ($(`#title-${me.titleId}`).length > 0) {
          me.setAnimation();
          $(document).scroll(me.setAnimation);
          clearInterval(interval);
        }
      }, 500);
    } else {
      const interval = setInterval(function () {
        if ($(`#title-${me.titleId}`).length > 0) {
          $(`#title-${me.titleId}`).removeClass("invisible");
          $(`#title-line-${me.titleId}`).removeClass("invisible");
          clearInterval(interval);
        }
      }, 500);
    }
    this.inLineLocal = this.inLine;
    this.onResize();
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  computed: {
    language() {
      return this.$store.getters["language/language"];
    },
    titleId() {
      let temp = this.title;
      if (this.title) {
        temp = temp.replaceAll(",", "-");
        return temp.replaceAll(" ", "-");
      } else {
        return null;
      }
    },
  },
  methods: {
    onResize() {
      this.screenSize =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      if (this.screenSize < 768) {
        this.inLineLocal = false;
      }
    },
    setAnimation() {
      const height = $(window).scrollTop() + $(window).height();
      if ($(`#title-${this.titleId}`).length > 0) {
        if (height > $(`#title-${this.titleId}`).offset().top) {
          $(`#title-${this.titleId}`)
            .addClass("animate__animated animate__fadeInUp")
            .removeClass("invisible");
        }
        if ($(`#title-line-${this.titleId}`).length > 0) {
          if (height > $(`#title-line-${this.titleId}`).offset().top) {
            $(`#title-line-${this.titleId}`)
              .addClass("animate__animated animate__fadeInUp")
              .removeClass("invisible");
          }
        }
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<style scoped>
.line {
  padding-bottom: 17px;
}
.animate__delay-0-5s {
  --animate-delay: 10s;
}
</style>